import {priority} from '@priority-software/priority-proto-api/lib';
import {getAppName, getWcfLogin, getNetFormDname} from '../../../_shared/GWTBridge/invoke/genPage';
import {getLang} from '../../../Localization';
import {getTabulaIni, getUserLogin, getUserPassword} from '../../../constants/metaData';
import {getUIAsapi} from '../../wasm/apiService';
import {getCompanyName} from '../../../utils/proto-api-utils/utils';

export const appName = 'APPUI';

type AdditionalProps = priority.netitems.metadata.IAdditionalProperties & {trace: boolean};

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams: any, prop) => searchParams.get(prop)
});

export const getAdditionalProps = (dname?: string): AdditionalProps => {
    const company = dname || getNetFormDname() || getCompanyName();
    return {
        ApplicationName: getAppName() || appName,
        Debug: !!params._ds,
        Dname: company,
        Language: Number(getLang()),
        Timezone: getTimeZone(),
        PluginEnabled: false,
        Tabulaini: getTabulaIni(),
        TenantID: '',
        Asapi: getUIAsapi(),
        Credentials: getSimpleCredentials(),
        Userlogin: getUserLogin(),
        trace: false,
        DebugServer: params._ds
    };
};

export const getOdbcAdditionalProps = (): AdditionalProps => {
    const company = getCompanyName();
    return {
        ApplicationName: appName,
        Debug: params._ds === '1',
        Dname: company,
        Language: Number(getLang()),
        Timezone: getTimeZone(),
        PluginEnabled: false,
        Tabulaini: getTabulaIni(),
        TenantID: '',
        Asapi: getUIAsapi(),
        Credentials: isOpenidLogin() ? getBearerCredentials() : getSimpleCredentials(),
        Userlogin: getUserLogin(),
        trace: false
    };
};

export const isOpenidLogin = () => {
    return getWcfLogin() === 'oidc_jwt';
};

export const getSimpleCredentials = (): priority.netitems.metadata.ICredentials => {
    return {
        Simple: {
            Userlogin: getWcfLogin(),
            Password: getUserPassword()
        }
    };
};

export const getBearerCredentials = (): priority.netitems.metadata.ICredentials => {
    return {
        Openid: {
            Token: getUserPassword()
        }
    };
};

export const getTimeZone = (): priority.netitems.metadata.ITimeZone => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
        Diff: -new Date().getTimezoneOffset(),
        IANA: tz
    };
};
